<template>
  <div class="py-2">

    <label :for="label" class="block text-sm font-medium text-gray-700">
      {{label}}
    </label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{description}}
    </div>    
    <Combobox v-model="selected" >
      <div class=" relative mt-1">
        <div class="relative">          
          <ComboboxButton v-if="selected != ''" @click="unSelected()" class="absolute right-8 top-3">
            <XMarkIcon class="h-4 cursor-pointer"/>
          </ComboboxButton>
          <ComboboxInput  class="defaultInput" :displayValue="(item) => item.name"  @change="searchTo" />  
          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2" >
            <ArrowsUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </ComboboxButton>
        </div>
        <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" @after-leave="query = ''">        
          <ComboboxOptions class=" z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            <div v-if="filteredDataRows.length === 0 && query !== ''" class="relative cursor-default select-none py-2 px-4 text-gray-700">
              Not found
            </div>
            <ComboboxOption v-for="item in filteredDataRows" as="template" :key="item.id" :value="item" v-slot="{ selected, active }">

              <li @click="update(item)" class="relative cursor-default select-none py-2 pl-10 pr-4" :class="{ 'bg-indigo-600 text-white': active, 'text-gray-900': !active,}">
                
                <span class="block truncate flex" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                  <div  class="pr-2">
                    <div v-html="checkStatus(item.status)"></div>
                  </div>                  
                  <div  class="pr-2">
                    <img  :src="item.avatar || '/imgs/avatar.jpg'"  class="inline-block h-5 w-5 rounded-full " />          
                  </div>
                  {{ item.name }}
                </span>
                <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3" :class="{ 'text-white': active, 'text-teal-600': !active }">
                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
              </li>
            </ComboboxOption>
          </ComboboxOptions>
        </TransitionRoot>
      </div>
    </Combobox>
    
  </div>
</template>

<script>


import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

import { CheckIcon, ArrowsUpDownIcon, XMarkIcon } from '@heroicons/vue/24/solid'

export default {

  name: 'DropDownSearchBots',
  props: {
    label: String,
    description: String,    
    settings_workspaces_id: String,
    show_user: {
      type: Boolean,
      default: true,
    },
    value: [String, Object, Boolean],  

  },
  data() {
    return {
      urlBots: 'core/components/fields/bots',
      dataRows: [],
      query: '',
      item: {},
      selected: '',
      params: {
        settings_workspaces_id: '',
      },
    }
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
    CheckIcon,
    ArrowsUpDownIcon,
    XMarkIcon,

  },
  methods: {

    checkStatus(objStatus){
      if(objStatus == 'active'){
        return '<span class="text-green-500">●</span>'
      }
      else{
        return '<span class="text-red-500">●</span>'
      }
    },


    getBots(){


        this.$ApiService.post(this.urlBots, this.params).then(response => {
            // Caso não seja para mostrar o usuárial atual (logado)
            this.dataRows = response.data;


            if (this.value) {
              this.selected = this.dataRows.find((dr) => dr.id === this.value);
            }
        });
    },

    searchTo($event) {
      this.query = $event.target.value
    },

    unSelected() {
      this.selected = '';
      this.$emit('update:modelValue', null);
    },

    update(item) {
      this.item = item;
      this.$emit('update:modelValue', this.item.id);
    },


    search(item) {
      return (item.name||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1
    },

  },

  computed: {
    filteredDataRows() {

      // Impede que sejam mostrados dados (apenas não retorna nada)
      if(!this.dataRows){
        return ''
      }

      return this.dataRows.filter(item => {
        if(this.search(item)){ return item.name}          
      });

    },
  },
  watch: {

    settings_workspaces_id(newValue) {
      this.params.settings_workspaces_id = newValue;
      this.selected = '';
      this.$emit('update:modelValue', null);
      this.getBots();
    },
  },

  created() {    
    this.params.settings_workspaces_id = this.settings_workspaces_id;
    this.getBots();
  },
}

</script>

